import type { Stop } from "../types";

type ById = Map<string, Stop> | Map<any, Stop>;

export function resolveStopId(
  raw: string | null | undefined,
  byId: ById,
  allStops?: Stop[]
): string | null {
  if (!raw) return null;

  const s = String(raw).trim();
  if (!s) return null;

  if ((byId as Map<string, Stop>).has(s)) return s;

  const asNum = Number(s);
  if (!Number.isNaN(asNum) && (byId as any).has(asNum)) return String(asNum);

  const root = s.split("-")[0];

  for (const k of (byId as any).keys()) {
    const key = String(k);
    if (key === root || key.startsWith(root + "-")) return key;
  }

  if (allStops?.length) {
    const exact = allStops.find((x) => String(x.id) === s);
    if (exact) return String(exact.id);

    const rootMatch = allStops.find((x) => {
      const id = String(x.id);
      return id === root || id.startsWith(root + "-");
    });
    if (rootMatch) return String(rootMatch.id);
  }

  return null;
}
